import React, { useState } from 'react';
import './DeleteModal.scss';
import CLOSE_ICON from '../../Images/closeImage.png';
import DELETE_ICON from '../../Images/deleteIcon.png';
import Button from '../common/Button';
import { Stack } from '@mui/material';

const SingleDelete = (props) => {
	const { closeModal, singleDeleteModal } = props;

	return (
		<div id="singleDeleteModal">
			<div id="myModal" className="delete-Modal">
				<div className="delete-Modal-content">
					<Stack justifyContent={'flex-end'} alignItems="flex-end">
						<img
							src={CLOSE_ICON}
							className="close_icon"
							onClick={closeModal}
							alt=""
						/>
					</Stack>
					<Stack justifyContent={'center'} alignItems="center" spacing={'2%'}>
						<img
							src={DELETE_ICON}
							className="close_icon"
							onClick={closeModal}
							width="75px"
							alt=""
						/>
						<p>
							Are you sure ?
							<Stack className="fs-4">You want to delete this record?</Stack>
						</p>
						<Stack direction={'row'} justifyContent="center" spacing={1}>
							<Button role="delete" value="Yes" onClick={singleDeleteModal}>
								Yes
							</Button>
							<Button role="export" value="No" onClick={closeModal}>
								No
							</Button>
						</Stack>
					</Stack>
				</div>
			</div>
		</div>
	);
};

export default SingleDelete;
